const colorRegular = '#ececec';
const colorHover = '#999999';
const colorSelected = '#3aec9c';

export default class CSRMapDataProvider {
  constructor(options) {
    this.dataProvider = options.data;
    this.originalImages = this.dataProvider.images;
  }

  getAreas() {
    return this.dataProvider.areas;
  }

  getImage() {
    return this.dataProvider.images;
  }

  getData() {
    return this.dataProvider;
  }

  getMapAreaForObject(obj) {
    if (obj.objectType === 'MapArea') {
      return obj;
    }
    if (obj.objectType === 'MapImage') {
      let area;
      for (let i = this.dataProvider.areas.length - 1; i >= 0; i--) {
        area = this.dataProvider.areas[i];
        if (area.id === obj.customData.id) {
          return area;
        }
      }
    }
    return obj;
  }

  setIsMobile(value) {
    this.isMobile = value;

    this.updateDefaultMapSettings();
    this.updateImageLabels();
  }

  setDetailSettings(isDetail, scale, long, lat) {
    this.isDetail = isDetail;

    if (this.isDetail) {
      this.updateDetailMapSettings(scale, long, lat);
    } else {
      this.updateDefaultMapSettings();
    }
  }

  updateDefaultMapSettings() {
    this.dataProvider.zoomLevel = this.isMobile ? 2.4 : 2.1;
    this.dataProvider.zoomLongitude = this.isMobile ? 57 : 54;
    this.dataProvider.zoomLatitude = this.isMobile ? 32 : 28;
  }

  updateDetailMapSettings(scale, long, lat) {
    this.dataProvider.zoomLevel = scale;
    this.dataProvider.zoomLongitude = long;
    this.dataProvider.zoomLatitude = lat;
  }

  setSelectedCountries(countries) {
    const a = this.dataProvider.areas;
    let c;
    this.selectedCountries = [];

    for (let i = 0, leni = a.length; i < leni; i++) {
      c = a[i];
      c.color = colorRegular;
      c.rollOverColor = colorHover;

      for (let j = 0, lenj = countries.length; j < lenj; j++) {
        if (c.id === countries[j]) {
          this.selectedCountries.push(c);
          c.color = c.rollOverColor = colorSelected;
          c.mouseEnabled = true;
        }
      }
    }
  }

  setSelectedCountry(country) {
    this.selectedCountries = [];
    this.isCountryActive = !!country;
    this.showCountryHoverForImage();
    this.updateAreas(country);
    this.updateImages(country);
    this.updateImageLabels();
  }

  showCountryHoverForImage(image, validate) {
    for (let i = this.dataProvider.areas.length - 1; i >= 0; i--) {
      const c = this.dataProvider.areas[i];
      c.color = image && c.id === image.customData.id ? colorHover : colorRegular;
      if (this.selectedCountries) {
        for (let j = this.selectedCountries.length - 1; j >= 0; j--) {
          if (this.selectedCountries[j].id === c.id) {
            c.color = colorSelected;
          }
        }
      }
      c.validate();
    }
    this.updateLabelOpacityForImage(image);
  }

  updateLabelOpacityForImage(image) {
    const id = image ? image.customData.id || image.id : false;
    for (let i = 0, leni = this.dataProvider.images.length; i < leni; i++) {
      const imgObj = this.dataProvider.images[i];
      const opacity = id && imgObj.customData.id !== id ? '0.08' : '1';
      imgObj.displayObject.node.style.opacity = opacity;
    }
  }

  updateImageLabels() {
    [...this.dataProvider.images].map(o => {
      o.label = this.isMobile || this.isCountryActive ? '' : o.customData.label;
      o.scale = this.isMobile ? o.customData.scale.mobile : o.customData.scale.desktop;
    });
  }

  updateAreas(country) {
    const { areas } = this.dataProvider;
    for (let i = 0, leni = areas.length; i < leni; i++) {
      const c = areas[i];
      if (country) {
        c.mouseEnabled = false;
        c.rollOverColor = colorHover;
        c.color = colorRegular;
        if (country.id !== c.id) {
          c.showAsSelected = false;
        } else {
          c.showAsSelected = true;
        }
      } else {
        c.showAsSelected = false;
        c.mouseEnabled = true;
      }
    }
  }

  updateImages(country) {
    const images = this.originalImages;
    this.dataProvider.images = [];
    for (let i = 0, leni = images.length; i < leni; i++) {
      const img = images[i];
      if (country) {
        img.mouseEnabled = false;
        if (country.id === img.customData.id) {
          this.dataProvider.images.push(img);
        }
      } else {
        img.mouseEnabled = true;
      }
    }
    if (!country) {
      this.dataProvider.images = this.originalImages;
    }
  }
}
